import { cn } from "@/lib/utils";
import { useToastStore } from "@/stores/ui";

export function Toaster() {
  const message = useToastStore((s) => s.message);
  const visible = useToastStore((s) => s.visible);

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "fixed bottom-7 left-1/2 z-[100] -translate-x-1/2 rounded-full border border-border bg-secondary px-5 py-2.5 text-sm text-foreground shadow-2xl transition-all duration-200",
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-5 opacity-0"
      )}
    >
      {message}
    </div>
  );
}
